var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video)?_c('div',{staticClass:"starter__video"},[_c('h1',[_vm._v(_vm._s(_vm.deleteItemVideo))]),_c('video',{attrs:{"loop":"","muted":"","autoplay":"","playsinline":"","preload":"auto","src":_vm.video},domProps:{"muted":true}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }